import React, { useState, useEffect, useRef } from 'react';
import '../styles/faq.css';

const faqData = [
  {
    question: 'What happens during the first consultation?',
    answer: 'During your first consultation, the psychiatrist will take time to understand your concerns, symptoms, personal circumstances, and relevant history. Based on this assessment, a personalized treatment plan will be discussed with you, taking your preferences and goals into consideration.',
  },
  {
    question: 'How do I know if I should see a psychiatrist?',
    answer: 'If you are experiencing emotional, behavioral, or psychological difficulties that are affecting your daily life, relationships, work, studies, or overall well-being, a psychiatric consultation may be beneficial. Seeking help early can often prevent symptoms from worsening and improve long-term outcomes.',
  },
  {
    question: 'Are psychiatric medications safe?',
    answer: 'When prescribed appropriately and monitored by a qualified psychiatrist, psychiatric medications are generally safe and effective. Before starting any medication, the expected benefits, possible side effects, and any necessary precautions will be discussed with you, allowing you to make an informed decision about your treatment.',
  },
  {
    question: 'Is online consultation available?',
    answer: 'Yes. We offer secure video consultations for individuals who are unable to visit the clinic in person or prefer the convenience of online care. Appointments for online consultations can be booked through our website or by contacting the clinic directly.',
  },
  {
    question: 'Do you provide counseling or psychotherapy?',
    answer: 'Yes. Depending on your individual needs, counseling or psychotherapy may be recommended as part of your treatment plan. We work with a clinical psychologist who has a special interest in Cognitive Behavioural Therapy (CBT), trauma-focused therapies, couple therapy, and family therapy. Therapy recommendations are tailored to each individual\'s concerns and treatment goals.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const sectionRef = useRef(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.fade-up');
    elements?.forEach((el) => observer.observe(el));
    return () => elements?.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <section className="faq-section" id="faq" ref={sectionRef}>
      <div className="container">
        <div className="section-header fade-up">
          <span className="section-tag">FAQ</span>
          <h2>Common questions</h2>
        </div>

        <div className="faq-list fade-up">
          {faqData.map((item, i) => (
            <div className={`faq-item ${openIndex === i ? 'open' : ''}`} key={i}>
              <button
                className="faq-question"
                onClick={() => toggleFaq(i)}
                aria-expanded={openIndex === i}
              >
                {item.question}
                <span className="faq-toggle">+</span>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
